module.exports = __webpack_public_path__ + "img/defaultmarker.6b664ce8.png";